import { Box, Typography } from '@mui/material';

type Props = {
  message: string;
  minHeight?: number | string;
};

export const EmptyState = ({ message, minHeight = 250 }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight,
        border: theme => `1px dashed ${theme.palette.divider}`,
        borderRadius: 2,
        backgroundColor: theme =>
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.02)'
            : 'rgba(0, 0, 0, 0.02)'
      }}
    >
      <Typography variant="body1" color="text.secondary" align="center">
        {message}
      </Typography>
    </Box>
  );
};
